import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as React from 'react'
import { deleteJSON, postJSON } from '@/lib/api'
import type { PipelineRow } from '@/pages/RenewalPipelinePage.types'

const dismissalPath = (membershipId: number) =>
  `/api/v1/renewal_pipeline/memberships/${membershipId}/dismissal`

export function useRenewalDecisionDismissal(onError: (message: string) => void) {
  const queryClient = useQueryClient()
  const [dismissedMember, setDismissedMember] = React.useState<Pick<
    PipelineRow,
    'membership_id' | 'name'
  > | null>(null)
  const dismiss = useMutation({
    mutationFn: (row: PipelineRow) => postJSON(dismissalPath(row.membership_id), {}),
    onSuccess: async (_data, row) => {
      setDismissedMember(row)
      await queryClient.invalidateQueries({ queryKey: ['renewal-pipeline'] })
    },
    onError: () => onError('The Needs decision entry could not be dismissed.'),
  })
  const undo = useMutation({
    mutationFn: (membershipId: number) => deleteJSON(dismissalPath(membershipId)),
    onSuccess: async () => {
      setDismissedMember(null)
      await queryClient.invalidateQueries({ queryKey: ['renewal-pipeline'] })
    },
    onError: () => onError('The Needs decision dismissal could not be undone.'),
  })

  return { dismiss, undo, dismissedMember }
}
